export const validateEmail = (email: string) => {
  const re = /\S+@\S+\.\S+/;

  return re.test(email);
};

export const validateName = (name: string) => {
  const re = /^[A-Za-zŽžÀ-ÿ ,.'-]+$/;

  return re.test(name);
};

export const validatePassword = (password: string) => {
  return password.length > 7;
};

export const validateNewPassword = (password: string) => {
  const re =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.£<>+_=;:()/?|{}'"\\[\]`~-])(?=.{8,})/;

  return re.test(password);
};
